export default "__VITE_ASSET__CbzUSpE___"